import uniq from 'lodash/uniq'

import api from '../../../api'

export default orderId => {
  const body = {
    filters: {
      order_id: orderId
    }
  }

  return api.get('admin/order_items', { body })
    .then(res => res.json())
    .then(orderItems => {
      if (orderItems.length === 0) return []

      const body = {
        filters: {
          product_id_in: uniq(orderItems.map(orderItem => orderItem.product_id))
        }
      }

      return api.get('admin/discounts', { body })
        .then(res => res.json())
    })
}
